var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { jsx } from "react/jsx-runtime";
import * as React from "react";
import { toastr } from "react-redux-toastr";
var NotificationSource = /* @__PURE__ */ ((NotificationSource2) => {
  NotificationSource2["onErrorDecorator"] = "onErrorDecorator";
  NotificationSource2["popupLogProvider"] = "popupLogProvider";
  return NotificationSource2;
})(NotificationSource || {});
const _NotificationService = class _NotificationService {
  constructor(component) {
    __publicField(this, "component", null);
    this.component = component;
  }
  setComponent(component) {
    this.component = component;
  }
  success(message) {
    toastr.success("Success", message, _NotificationService.toastrOptions);
  }
  customError(title, content, additionalSettings) {
    toastr.error(title, "", __spreadValues(__spreadProps(__spreadValues({}, _NotificationService.toastrOptions), {
      component: content
    }), additionalSettings));
  }
  warn(warnObject) {
    this.warnFull(warnObject);
  }
  error(notificationSource, errorObject) {
    this.errorFull(notificationSource, errorObject);
  }
  warnFull(warnObject) {
    toastr.warning("Warning", "", __spreadProps(__spreadValues({
      // @ts-ignore
      component: (p) => /* @__PURE__ */ jsx(this.component, __spreadValues({}, warnObject))
    }, _NotificationService.toastrOptions), {
      position: "top-center",
      timeOut: 0
    }));
  }
  errorFull(notificationSource, errorObject) {
    toastr.error(
      "Error",
      "",
      Object.assign(
        Object.assign(
          // @ts-ignore
          { component: (p) => React.createElement(this.component, Object.assign({}, { notificationSource }, errorObject)) },
          _NotificationService.toastrOptions
        ),
        { position: "top-center", timeOut: 0 }
      )
    );
  }
};
__publicField(_NotificationService, "toastrOptions", {
  newestOnTop: false,
  position: "top-right",
  preventDuplicates: false,
  progressBar: true,
  timeOut: 0,
  removeOnHover: false,
  transitionIn: "fadeIn",
  transitionOut: "fadeOut"
});
let NotificationService = _NotificationService;
const NotificationService$1 = new NotificationService();
export {
  NotificationService,
  NotificationSource,
  NotificationService$1 as default
};
//# sourceMappingURL=NotificationService.js.map
